<template>
  <!-- Membership Markup Starts Here -->
  <div id="membership-markup">
    <div class="allMembershipContent">
      <!-- Top Navbar Component -->
      <Navbar
        :navLogo="navLogo"
        :user="user"
        :isPreview="isPreview"
        :logout="logout"
        :profile="profile"
        :membershipOutline="membershipOutline"
        :changePage="changePage"
        :backPortalPage="backPortalPage"
        :isPortal="isPortal"
      />
      <!-- Main Content Starts Here -->
       <div class="w-full pb-64 bg-grey-100" :class="{ 'lg:px-20': !isPreview }">
        <div class="md:flex pb-4">
          <!-- Left Section Starts Here -->
          <div class="sm:w-full md:w-1/3 max-h-content p-4" id="main-body-area">
            <!-- Banner Component -->
            <FeatureImage :featureImage="featureImage" />

            <!-- Progress Component -->
            <ProgressBar
              v-if="showProgressBar == '1'"
              :progressBar="progressBar"
              :showProgressBar="showProgressBar"
            />

            <!--Only for mobile screen-->
            <div class="block md:hidden" v-if="!isPreview">
              <PageContent
                :pageContent="pageContent"
                :isPreview="isPreview"
                :preNextOptions="preNextOptions"
                :changePage="changePage"
                :postLocked="postLocked"
                :postAccess="postAccess"
              />
            </div>

            <div v-if="!isPreview">
              <div class="">
                <PrevNextButtonMobile
                  class="block md:hidden"
                  :isPreview="isPreview"
                  :preNextOptions="preNextOptions"
                  :changePage="changePage"
                />
              </div>
            </div>

            <!-- Instructor Component -->
            <Instructor class="hidden md:block" :instructor="instructor" />

            <!-- Selected Currrent Hierarchy Component -->
            <CurrentHierarchy
              :selectedPotsHierarchyData="selectedPotsHierarchyData"
              :changePage="changePage"
            />

            <!-- Instructor Component only for mobile-->
            <Instructor class="block md:hidden" :instructor="instructor" />

            <!-- Membership Out line Component  -->
            <MembershipOutline
              class="hidden md:block"
              :membershipOutline="membershipOutline"
              :changePage="changePage"
              :isPreview="isPreview"
            />
          </div>

          <!-- Left Section Ends Here -->

          <!-- Right Section Starts Here -->
          <div class="sm:w-full md:w-2/3 max-h-content">
            <div class="rounded-md hidden md:block">
              <!-- Main Content Component -->
              <PageContent
                :pageContent="pageContent"
                :isPreview="isPreview"
                :preNextOptions="preNextOptions"
                :changePage="changePage"
                :postLocked="postLocked"
                :postAccess="postAccess"
              />
            </div>

            <!-- Comment Section  -->

            <!-- <CommentSection :isPreview="isPreview" /> -->
          </div>

          <!-- Right Section Ends Here -->
        </div>
      </div>
      <!-- Main Content Ends Here -->
    </div>
  </div>
  <!-- Membership Markup Ends Here -->
</template>
<script>
import Navbar from './top-navbar/navbar';
import FeatureImage from './left-panel/feature-image.vue';
import ProgressBar from './left-panel/progressbar.vue';
import Instructor from './left-panel/instructor.vue';
import CurrentHierarchy from './left-panel/current-hierarchy.vue';
import MembershipOutline from './left-panel/membership-outline.vue';
import PageContent from './main-panel/page-content.vue';
import CommentSection from './main-panel/comment/comment-section.vue';
import PrevNextButtonMobile from './main-panel/mobile/prev-next-button';

export default {
  name: 'MembershipMarkup',
  components: {
    Navbar,
    FeatureImage,
    ProgressBar,
    Instructor,
    CurrentHierarchy,
    MembershipOutline,
    PageContent,
    CommentSection,
    PrevNextButtonMobile,
  },
  data() {
    return {
      // user: { name: 'Prakash Saini' },
    };
  },
  mounted(){
     console.log(this.isPreview,'is preview');
  },
  props: [
    'isPreview',
    'navLogo',
    'featureImage',
    'showProgressBar',
    'progressBar',
    'instructor',
    'selectedPotsHierarchyData',
    'membershipOutline',
    'changePage',
    'pageContent',
    'preNextOptions',
    'user',
    'logout',
    'profile',
    'backPortalPage',
    'isPortal',
    'postAccess',
    'postLocked',
  ],
};
</script>
<style lang="scss">
[data-gp-component='video-youtube'] > div > iframe,
[data-gp-component='video-vimeo'] > div > iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  pointer-events: none;
  left: 0px;
}

.allMembershipContent {
  font-family: 'Nunito Sans', sans-serif;
}
</style>
